import React from 'react'
import { useDimensions } from 'src/ui/dimensions'

import { Learn as Desc } from './desk'
import { Learn as Mob } from './mob'

type Props = {
  images: TImages
}
export const Learn: React.FC<Props> = ({ images }) => {
  const { isMobile } = useDimensions()
  return isMobile ? <Mob images={images} /> : <Desc images={images} />
}
